// Authentication/User reducer types
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";
export const SET_USER_DATA = "SET_USER_DATA";
// UI reducer types
export const SET_SIDEBAR = "SET_SIDEBAR";
export const SET_ERRORS = "SET_ERRORS";
export const LOADING_UI = "LOADING_UI";
export const CLEAR_ERRORS = "CLEAR ERRORS";
export const LOADING_DATA = "LOADING_DATA";
export const STOP_LOADING_UI = "STOP_LOADING_UI";
export const SET_VERSION = "SET_VERSION";
// Data reducer types
export const SET_SHEETS = "SET_SHEETS";
export const LOADING_COMPOSERS = "LOADING_COMPOSERS";
export const SET_COMPOSERS = "SET_COMPOSERS";
export const RESET_DATA = "RESET_DATA";
export const SET_USERS_DATA = "SET_USERS_DATA";
export const UPDATE_SHEET_DATA = "UPDATE_SHEET_DATA";

// Sheet Pages
export const SET_PAGE_SHEETS = "SET_PAGE_SHEETS"; // Data
export const INCREMENT_SHEET_PAGE = "INCREMENT_SHEET_PAGE";
export const DECREMENT_SHEET_PAGE = "DECREMENT_SHEET_PAGE";
export const SET_SHEET_PAGE = "SET_SHEET_PAGE"; // What Page are we on
export const SET_TOTAL_SHEET_PAGES = "SET_TOTAL_SHEET_PAGES";

// Composer Pages
export const SET_PAGE_COMPOSERS = "SET_PAGE_COMPOSERS"; // Data
export const INCREMENT_COMPOSER_PAGE = "INCREMENT_COMPOSER_PAGE";
export const DECREMENT_COMPOSER_PAGE = "DECREMENT_COMPOSER_PAGE";
export const SET_COMPOSER_PAGE = "SET_COMPOSER_PAGE"; // What page are we on
export const SET_TOTAL_COMPOSER_PAGES = "SET_TOTAL_COMPOSER_PAGES";
export const UPDATE_COMPOSER_DATA = "UPDATE_COMPOSER_DATA"; 
